export const SNAPPY_URL = 'https://www.snappy.com/integrations/medallia';
